module.exports = "/images/01-clock.svg?bc4f32f8996798be9aecbc2e79e92062";